// 提交申请前的详情
import zwitCore from "./config/http";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  // 提交申请前的详情
  getBeforeSubmitDetail(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/afterSalesOrder/getBeforeSubmitDetail",
      data,
      false
    );
  },
  // 提交售后申请
  submitOrder(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/afterSalesOrder/submit",
      params,
      false
    );
  },
  // 售后单详情
  detailOrder(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/afterSalesOrder/detail",
      data,
      false
    );
  },

  // 售后列表
  afterSaleList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/afterSalesOrder/pageList",
      data,
      false
    );
  },

  // 撤销售后
  repealAfterSale(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-order/afterSalesOrder/revoke/${data.id}`,
      data,
      false
    );
  },

  // 设置邮寄信息
  setMail(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/afterSalesOrder/setMail",
      data,
      false
    );
  },

  // 获取售后类型列表
  getAfterSalesType(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        `/zw-order/afterSalesOrder/getAfterSalesType?orderGoodsId=${data.orderGoodsId}`,
      data,
      false
    );
  },

  // 获取售后进度时间
  getRemainderTime(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        `/zw-order/afterSalesOrder/getRemainderTime/${data.afterSalesOrderIdId}/${data.redisKey}`,
      data,
      false
    );
  },

  // 重新提交申请售后前校验
  reapplyVerify(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-order/afterSalesOrder/beforeSubmitCheck/${data.subOrderId}/${data.orderGoodsId}`,
      data,
      false
    );
  },

  // 重新提交申请售后前校验
  closeAfterSales(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-order/afterSalesOrder/close/${data.id}`,
      data,
      false
    );
  },

  // 重新提交申请售后前校验
  applyIntervene(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-order/afterSalesIntervene/submitIntervene/${data.afterSalesOrderId}`,
      data.detail,
      false
    );
  },

  // 售后退换货买家发物流信息(发货)
  submitBuyerLogistics(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-order/afterSalesOrder/buyerShipments/${data.afterSalesOrderId}`,
      data,
      false
    );
  },

  // 买家售后确认收货
  toConfirmReceipt(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-order/afterSalesOrder/confirmReceipt/${data.afterSalesOrderId}`,
      data,
      false
    );
  },
  
  // 买家售后延长收货时间
  toLengthenReceipt(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-order/afterSalesOrder/extendedReceipt/${data.afterSalesOrderId}/${data.redisKey}`,
      data,
      false
    );
  },

  // 线下退款售后详情
  offlineSalesDetail(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        `/zw-order/afterSales/offline/${data.id}`,
      data,
      false
    );
  },
};
